export default "__VITE_ASSET__BOrTIw0d__"